<template>
  <table class="admin__table">
    <tr>
      <th>Name</th>
      <th>Email</th>
      <th>Date</th>
      <th>Admin Responded</th>
    </tr>
    <tr v-for="signup in signups" :key="signup.document_id">
      <td>{{ signup.name }}</td>
      <td>{{ signup.email }}</td>
      <td>{{ signup.date.toDate().toLocaleString() }}</td>
      <td>
        <div style="display: flex; justify-content:center; ">
          <input type="checkbox" class="toggle-switch__input" :id="signup.document_id" v-model="signup.admin_has_responded" :value="true" @change="adminHasResponded__changed($event, signup.document_id)" >
          <label class="toggle-switch__label toggle-switch__label--large toggle-switch__label--green-red" :for="signup.document_id">
          </label>
        </div>
      </td>
    </tr>
  </table>
</template>

<script>

import EmailSignup from "../../../models/EmailSignup";

export default {
  data(){
    return{
      signups: []
    }
  },
  async mounted(){
    this.signups = await EmailSignup.allByDate();

    console.log("this.signups", this.signups.length)
  },
  methods: {
    async adminHasResponded__changed(event, document_id) {
      let signup = this.signups.find(s => s.document_id == document_id)
      await signup.save();
    }
  }
}
</script>
